import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    CardText
} from "reactstrap"
import { SuccessOk, SuccessCreated } from "configs/statusCode"
import { AvForm, AvField, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import { toast } from "react-toastify"
import AreaService from "services/Admin/AreasService"
import SelectOptions from "components/SelectOptions"
import SalesRepsService from "services/Admin/SalesRepsService"
import CompoundService from "services/Admin/CompoundService"
import Select from "react-select";

function AreaModal({ modal, toggle, id, setShouldGetData, type  ,salesRep}) {
    const [loading, setLoading] = useState(false)
    const salesRepsService = new SalesRepsService()
    const [compoundOptions, setCompoundOptions] = useState([])
    const [salesRepOptions, setSalesRepOptions] = useState([])

    const [areaOptions, setAreaOptions] = useState([])
    const [formData, setFormData] = useState({
        area_ids: [],
        compound_ids: [],
        sales_rep_id: null
    })

     useEffect(() => {
        setFormData({
             sales_rep_id: salesRep
        })
    },[])

    useEffect(() => {
        if (id) {
            salesRepsService.find(id).then(response => {
                if (response && response.status === SuccessOk) { 
                    setFormData({
                        compound_ids: response.data.compounds.map(item => ({ label: item.name.en, value: item.id })),
                        area_ids: response.data.areas.map(item => ({ label: item.name.en, value: item.id })),
                    })
                }
            })

        }
    }, [])

    const handleFieldChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const handleValidSubmit = (_, values) => {
        setLoading(true)
        let data
        if (type === "Area") {
            data = {
                area_ids:JSON.stringify(formData?.area_ids)==="null" ? []: formData?.area_ids?.map(area => area.value),
                sales_rep_id: id,
            }
            salesRepsService.assignArea(data).then(res => {
                if (res && res.status === SuccessOk) {
                    setShouldGetData(true)
                    toast.success("Assign Area successfully ")
                    toggle()
                } else {
                    setLoading(false)
                }
            })
        } else {
             data = {
                compound_ids:JSON.stringify(formData?.compound_ids)==="null" ?[]:  formData?.compound_ids?.map(compound => compound.value),
                sales_rep_id: id,
            }
            salesRepsService.assignCompound(data).then(res => {
                if (res && res.status === SuccessOk) {
                    setShouldGetData(true)
                    toast.success("Assign Compound successfully ")
                    toggle()
                 } else {
                    setLoading(false)
                }
            })
        }
    }

    useEffect(() => {
        new SalesRepsService().getDropDown("all").then(res => {
            const newOptions = res.data.map(item => {
                return {
                    label: item.name.en ?item.name.en :item.name,
                    value: item.id
                }
            })
            setSalesRepOptions(newOptions)
        })
    }, [])

    return (
        <Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
            <AvForm
                className='form-horizontal'
                onValidSubmit={(e, v) => {
                    handleValidSubmit(e, v)
                }}>
                <ModalHeader toggle={toggle}>
                    {type === "Area" ? "Assign Location " : "Assign Compound"}
                    {/* <br /> */}
                    {/* <span className="font-size-14" style={{ opacity: .5, }}>Add title and description to can add feedback</span> */}
                </ModalHeader>
                <ModalBody>

                    <Row>
                        <Col md={12}>
                            <label>Sales Rep</label>
                            <Select
                                 placeholder='Select'
                                 options={salesRepOptions}
                                className='mb-3'
                                onChange={(data) => {
                                    setFormData({ ...formData, sales_rep_id: data });
                                }}
                                value={formData.sales_rep_id}
                                isDisabled={true}
                            />
                        </Col>
                        {type !== "Area" ? <Col md={12}   >
                            <SelectOptions
                                label='Compound'
                                placeholder='Select'
                                options={compoundOptions}
                                handleSelectChange={(data) => {
                                    setFormData({ ...formData, compound_ids: data });
                                }}
                                selectedOption={formData.compound_ids}
                                Service={CompoundService}
                                setOptions={(options) => {
                                    setCompoundOptions(options)
                                }}
                                isMulti={true}
                            />
                        </Col> :
                            <Col md={12}   >
                                <SelectOptions
                                    label='Location'
                                    placeholder='Select'
                                    options={areaOptions}
                                    handleSelectChange={(data) => {
                                        setFormData({ ...formData, area_ids: data });
                                    }}
                                    selectedOption={formData.area_ids}
                                    Service={AreaService}
                                    setOptions={(options) => {
                                        setAreaOptions(options)
                                    }}
                                    isMulti={true}
                                />
                            </Col>}
                    </Row>
                </ModalBody>

                <ModalFooter className="p-0 pt-1 m-0 d-flex justify-content-end">
                    <button
                        onClick={toggle}
                        type='button'
                        className='btn btn-secondary'>

                        Cancel
                        </button>
                    <button
                        type='submit'
                        disabled={loading ? true : false}
                        className='btn btn-success'>
                        Submit
                        </button>
                </ModalFooter>
            </AvForm>
        </Modal>

    )
}

export default AreaModal
